import table from "../../General CSS/Table.module.css";
import {Quote, getQuotes} from "../../API/QuotesManager";
import {useEffect, useState} from "react";

import add from "../../Images/add.png";
import Header from "../../Header";

export default function Quotes() {
    const [quotes, setQuotes] = useState<Quote[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect((): void => {
        getQuotes()
            .then((data) => {
                setQuotes(data);
            })
            .catch(err => setError(err.message || "Unknown Error"))
            .finally(() =>  {
                setLoading(false);
            });
    }, []);

    return (
        <>
            <Header
                page={"Quotes"}
                returnLink={"/"}
                links=
                    {[
                        {src: add, href: "/quotes/add", alt: "Add"}
                    ]}/>
            {quotes ? (
                <LoadQuotes quotes={quotes}/>
            ) : (
                <p>Loading Quotes...</p>
            )}
        </>
    );
}

function LoadQuotes({quotes}: LoadQuotesProps) {
    const changeOverDate = new Date("2025-07-01");

    function printQuotes(quotes: Quote[]) {
        return (
            <table>
                <colgroup>
                    <col style={{width: "70%"}}/>
                    <col style={{width: "10%"}}/>
                    <col style={{width: "10%"}}/>
                    <col style={{width: "10%"}}/>
                </colgroup>
                <thead>
                <tr>
                    <th>Quote Text</th>
                    <th>Said By</th>
                    <th>Added By</th>
                    <th>Date Said</th>
                </tr>
                {quotes.map((quote: Quote) => (
                    <tr key={quote.quoteId}>
                        <td><strong>{decodeHtml(quote.quote)}</strong></td>
                        <td>{quote.saidBy}</td>
                        <td>{quote.addedBy}</td>
                        <td>{
                            new Date(quote.date).toLocaleDateString("en-GB", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                            })
                        }</td>
                    </tr>
                ))}
                </thead>
            </table>
        )
    }
    return (
        <div className={table.table}>
            <div style={{paddingBottom: "10px"}}>
                <h2>2025-26</h2>
                { printQuotes(quotes.filter(quote => new Date(quote.date) >= changeOverDate)) }
            </div>
            <div style={{paddingBottom: "10px"}}>
                <h2>2024-25</h2>
                { printQuotes(quotes.filter(quote => new Date(quote.date) < changeOverDate)) }
            </div>
        </div>
    )
}

type LoadQuotesProps = {
    quotes: Quote[];
}

function decodeHtml(html: string): string {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent ?? "";
}